<template>
	<div class="uni">
		<div class="uni__elm">
			<div class="uni__elm-widget">
				<input
					ref="input"
					@input="onEvent"
					type="number"
					class="uni__elm-widget-input"
					:placeholder="label"
				/>
			</div>
			<div class="uni__elm-widget-error" v-if="isError">
				* {{ messageError }}
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
	props: {
		label: { type: String, default: "" },
		isError: { type: Boolean, default: false },
		messageError: {
			type: String,
			default: "Вводить только цифры",
		},
	},
})
export default class UiNumberInput extends Vue {
	public value = "";

	/**
	 * Обрабртка события input
	 * @param event
	 */
	public onEvent(event: Event) {
		this.value = (event.target as HTMLInputElement).value;
		this.$emit("input-balance", this.value);
	}
}
</script>

<style scoped lang="scss">
.uni {
	&__elm {
		display: flex;
		flex-direction: column;
		align-items: center;
		cursor: pointer;
	}

	&__elm-widget {
		padding: 10px;
		border: 1px solid rgb(244, 246, 250);
		border-radius: 12px;
		background-color: rgb(244, 246, 250);
		opacity: 1;
		width: 90%;
	}

	&__elm-widget-input {
		background-color: rgb(244, 246, 250);
		border: 1px solid rgb(244, 246, 250);
		font-size: 16px;
		width: 100%;
		-moz-appearance: textfield;
	}

	&__elm-widget-input:focus {
		outline-color: rgb(244, 246, 250);
		outline-style: solid;
	}

	&__elm-widget-input::-webkit-outer-spin-button,
	&__elm-widget-input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	&__elm-widget-error {
		padding: 4px;
		color: #ec5959;
		font-size: 14px;
	}
}
</style>
